import React from 'react';
import c from 'classnames';

import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import type { SearchBarButtonProps } from '@uncinc/react-searchkit/dist/components/SearchBar/Base';
import type { SearchResetButtonProps } from '@uncinc/react-searchkit/dist/components/Reset';

import ButtonWrapper from '../../ButtonWrapper';

import './style.scss';

const SearchBarButton = (buttonProps: SearchBarButtonProps) => (
  <ButtonWrapper
    {...buttonProps}
    iconName="search"
    type="secondary"
  />
);

const ResetButton = (buttonProps: SearchResetButtonProps) => (
  <ButtonWrapper
    {...buttonProps}
    iconName="close"
    type="primary"
    inverted
    variant="icon-only"
  />
);

const SearchAllContentSearchBar: React.FC<SearchBarProps> = (props) => {
  const { className, ...restProps } = props;

  const classNames = c('SearchAllContent__SearchBar', className);

  return (
    <SearchBar
      {...restProps}
      className={classNames}
      button={SearchBarButton}
      showReset
      resetProps={{
        button: ResetButton,
      }}
    />
  );
};

export default SearchAllContentSearchBar;
